export const adcivesFor = [
  {
    desc: "trip_desc_1",
  },
  {
    desc: "trip_desc_2",
  },
  {
    desc: "trip_desc_3",
  },
]
